import ButtonT from '@components/tailwind-components/Button/ButtonT';
import InputT from '@components/tailwind-components/Input/InputT';
import type { RevisionUpdateDTO } from '@conversed/rest/src/contracts';
import { t } from 'i18next';
import { useCallback } from 'react';
import { useForm } from 'react-hook-form';
import { useModal } from '../../../hooks/modal/useModal';
import { useMainSelector } from '../../../hooks/useMainSelector';
import { useRevisionsActions } from '../useRevisionsActions';

export const RevisionEditModal = () => {
  const { hideModal } = useModal();
  const { editRevision } = useRevisionsActions();
  const {
    designer: { editRevisionContent },
  } = useMainSelector();

  const { handleSubmit, control } = useForm({
    defaultValues: {
      name: editRevisionContent?.name ?? '',
      isMainRevision: editRevisionContent?.isMainRevision ?? false,
    },
    shouldUseNativeValidation: true,
  });

  const hideAndSubmit = useCallback(
    (data: RevisionUpdateDTO) => {
      const { _id: id } = editRevisionContent || {};

      if (!id) {
        return console.warn("selected revision doesn't exist");
      }

      editRevision(id, data);
      hideModal();
    },
    [editRevision, hideModal, editRevisionContent],
  );

  return (
    <form
      className='tailwind-modal-form'
      onSubmit={handleSubmit(hideAndSubmit)}>
      <div className='tailwind-modal-body'>
        <div className='grid grid-cols-1 gap-x-6 gap-y-2'>
          <div className='col-span-1'>
            <InputT
              field='name'
              type='text'
              control={control}
              placeholder={t('settings.revision.title')}
              options={{
                required: t('general.validation.required'),
              }}
            />
          </div>
        </div>
      </div>
      <div className='tailwind-modal-footer'>
        <ButtonT
          type='button'
          styling='cancel'
          size='xs'
          rounding='md'
          onClick={hideModal}>
          {t('general.buttons.cancel')}
        </ButtonT>
        <ButtonT type='submit' styling='primary' size='xs' rounding='md'>
          {t('general.buttons.save')}
        </ButtonT>
      </div>
    </form>
  );
};
